module.exports = __webpack_public_path__ + "static/media/front.4dea03f6.jpg";